"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputLabel = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var StyledLabel = styled_components_1.default.label(function (_a) {
  var theme = _a.theme,
      labelSize = _a.labelSize,
      disabled = _a.disabled,
      hasLeftIcon = _a.hasLeftIcon,
      floatingLabel = _a.floatingLabel,
      inputType = _a.inputType,
      error = _a.error,
      fontSize = _a.fontSize,
      isFloating = _a.isFloating,
      themeStyles = _a.themeStyles;
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: inline-block;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 600;\n    padding-left: 8px;\n    padding-bottom: 8px;\n    user-select: none;\n\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n  "], ["\n    display: inline-block;\n    color: ", ";\n    font-size: ", "px;\n    font-weight: 600;\n    padding-left: 8px;\n    padding-bottom: 8px;\n    user-select: none;\n\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n  "])), theme.colors.primary, labelSize, floatingLabel && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        color: ", ";\n        position: absolute;\n        font-size: ", "px;\n        font-weight: 400;\n        top: 50%;\n        left: 8px;\n        transform: translateY(-50%);\n        transition: all 250ms;\n        padding: 0;\n\n        &:hover {\n          cursor: text;\n        }\n\n        ", "\n\n        ", "\n\n        ", "\n      "], ["\n        color: ", ";\n        position: absolute;\n        font-size: ", "px;\n        font-weight: 400;\n        top: 50%;\n        left: 8px;\n        transform: translateY(-50%);\n        transition: all 250ms;\n        padding: 0;\n\n        &:hover {\n          cursor: text;\n        }\n\n        ", "\n\n        ", "\n\n        ", "\n      "])), themeStyles.color || theme.colors.greyDark, fontSize, hasLeftIcon && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding-left: ", "px;\n          "], ["\n            padding-left: ", "px;\n          "])), fontSize + 8), inputType === 'textarea' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            top: 16px;\n          "], ["\n            top: 16px;\n          "]))), isFloating && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            top: 6px;\n            transform: translateY(0);\n            font-size: ", "px;\n            font-weight: 600;\n            color: ", ";\n\n            ", "\n          "], ["\n            top: 6px;\n            transform: translateY(0);\n            font-size: ", "px;\n            font-weight: 600;\n            color: ", ";\n\n            ", "\n          "])), fontSize - 4, themeStyles.floatingColor || theme.colors.primary, hasLeftIcon && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                padding-left: ", "px;\n              "], ["\n                padding-left: ", "px;\n              "])), labelSize + 4))), error && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.colors.red), disabled && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        color: ", ";\n\n        &:hover {\n          cursor: default;\n        }\n      "], ["\n        color: ", ";\n\n        &:hover {\n          cursor: default;\n        }\n      "])), theme.colors.disabledColor), themeStyles);
});

function InputLabel(props) {
  var children = props.children,
      variant = props.variant;
  var theme = styled_components_1.useTheme();
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'InputLabel', variant, 'default');
  return React.createElement(StyledLabel, __assign({
    themeStyles: themeStyles
  }, props), children);
}

exports.InputLabel = InputLabel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;